module.exports = __webpack_public_path__ + "media/images/lp_chintai/sec05_img_01-3320f77900f3819a0e8db31c25fc80cf.png";